import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { CompraEditPage } from '@/features/compra/page/edit/CompraEditPage';
import { StringToIdpkSchema } from '@/std/schema';

const RouteCompraParamsSchema = z.discriminatedUnion('action', [
    z.object({
        action: z.literal('cadastrar'),
        idpk: z.undefined().optional(),
    }),
    z.object({
        action: z.enum(['editar', 'visualizar']),
        idpk: StringToIdpkSchema,
    }),
]);

export const Route = createFileRoute('/a/compra/$action/{-$idpk}')({
    component: Component,
    params: {
        parse: (params) => {
            const result = RouteCompraParamsSchema.safeParse(params);

            return result.success ? result.data : false;
        },
    },
});

function Component() {
    const params = Route.useParams();

    return <CompraEditPage {...params} />;
}
